<div
  class="activity-display"
  [hidden]="neverShowActivityDisplay || (!showActivityDisplay && !neverShowActivityDisplay)"
>
  <jf-accordion
    [expanded]="isExpansionpanelOpen"
    (expandedChanged)="changeExpansionpanelState($event)"
    [showBorder]="false"
    [arrowPosition]="'right'"
    [clickArea]="'full'"
  >
    <div title class="activity-header">
      <div *ngIf="activitiesOngoingCount === 0" [ngPlural]="activities.length">
        <ng-template ngPluralCase="one">1 abgeschlossene Aktivität</ng-template>
        <ng-template ngPluralCase="other">{{ activities.length }} abgeschlossene Aktivitäten</ng-template>
      </div>

      <div *ngIf="activitiesOngoingCount > 0" [ngPlural]="activitiesOngoingCount">
        <ng-template ngPluralCase="one">1 laufende Aktivität</ng-template>
        <ng-template ngPluralCase="other">{{ activitiesOngoingCount }} laufende Aktivitäten</ng-template>
      </div>
    </div>

    <div content class="activities">
      <app-activity *ngFor="let activity of activities" [value]="activity"></app-activity>
    </div>
  </jf-accordion>

  <jf-button
    class="close-btn"
    [size]="'circle'"
    [variant]="'ghost'"
    [iconPosition]="'icon-only'"
    [iconColor]="'#CCCCCC'"
    [icon]="'close'"
    (doClick)="hideActivityDisplay()"
  ></jf-button>
</div>
